"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_CLIENT = 'SET_CLIENT';
exports.SET_TENANT = 'SET_TENANT';
exports.LOAD_CERTIFICATES = 'LOAD_CERTIFICATES';
exports.LOAD_CERTIFICATE = 'LOAD_CERTIFICATE';
exports.CREATE_CERTIFICATE = 'CREATE_CERTIFICATE';
exports.UPDATE_CERTIFICATE = 'UPDATE_CERTIFICATE';
exports.LOAD_CLIENTS = 'LOAD_CLIENTS';
exports.LOAD_CLIENT = 'LOAD_CLIENT';
exports.CREATE_CLIENT = 'CREATE_CLIENT';
exports.UPDATE_CLIENT = 'UPDATE_CLIENT';
exports.LOAD_CURRENT_USER = 'LOAD_CURRENT_USER';
exports.UPDATE_CURRENT_USER = 'UPDATE_CURRENT_USER';
exports.LOAD_TENANT = 'LOAD_TENANT';
exports.LOAD_TENANTS = 'LOAD_TENANTS';
exports.CREATE_TENANT = 'CREATE_TENANT';
exports.UPDATE_TENANT = 'UPDATE_TENANT';
exports.SELECT_TENANT = 'SELECT_TENANT';
exports.ADD_TENANT_PERMISSION = 'ADD_TENANT_PERMISSION';
exports.REMOVE_TENANT_PERMISSION = 'REMOVE_TENANT_PERMISSION';
exports.SET_TENANT_ACCESSIBILITY = 'SET_TENANT_ACCESSIBILITY';
exports.LOAD_PUBLIC_TENANT = 'LOAD_PUBLIC_TENANT';
exports.LOAD_PUBLIC_TENANTS = 'LOAD_PUBLIC_TENANTS';
exports.LOAD_USERS = 'LOAD_USERS';
exports.LOAD_USER = 'LOAD_USER';
exports.CREATE_USER = 'CREATE_USER';
exports.UPDATE_USER = 'UPDATE_USER';
exports.LOAD_PUBLIC_USERS = 'LOAD_PUBLIC_USERS';
exports.LOAD_PUBLIC_USER = 'LOAD_PUBLIC_USER';
exports.SIGNIN_USER = 'SIGNIN_USER';
exports.REFRESH_USER_TOKENS = 'REFRESH_USER_TOKENS';
exports.SIGNOUT_USER = 'SIGNOUT_USER';
exports.FORGOT_PASSWORD = 'FORGOT_PASSWORD';
exports.RESET_PASSWORD = 'RESET_PASSWORD';